import { makeAutoObservable, runInAction } from 'mobx';
import get from 'lodash/get';
import { requestGet, requestPost } from '../../services/real.backend';
import { API_SETTINGS_UPLOAD_IMAGE, API_USER_UPLOAD_AVATAR } from '../../services/apiPoints';

class SettingsStorage {
  texts = {
    converstionStart: null,
    noPhone: null,
    afterPhoneReceived: null,
    requestPhone: null,
    textForSharePhone: null,
    textForEsputnikViber: null,
    textForEsputnikViberButton: null,
    textForEsputnikViberImage: null,
  }

  textsChanged = {}

  constructor() {
    makeAutoObservable(this);
  }

  get isTextsChanged() {
    return Object.keys(this.textsChanged).length > 0;
  }

  changeTextField = (fieldName, value) => {
    if (this.texts?.[fieldName]?.content !== undefined) {
      this.texts[fieldName] = { ...this.texts[fieldName], content: value };
      this.textsChanged = { ...this.textsChanged, [fieldName]: true };
    }
  }

  loadTexts = () => {
    requestGet('/api/texts')
      .then((response) => {
        if (response.status === 'success') {
          this.setTexts(response.texts);
          this.textsChanged = {};
        }
      });
  }

  saveTexts = () => {
    requestPost('/api/texts', {
      texts: Object.keys(this.textsChanged)
        .map((key) => (this.textsChanged[key] ? this.texts[key] : null))
        .filter((v) => !!v),
    })
      .then((response) => {
        if (response.status === 'success') {
          this.setTexts(response.texts);
          this.textsChanged = {};
        }
      });
    // this.textsChanged = {};
  }

  setTexts = (textsArray) => {
    textsArray.forEach((text) => {
      switch (text.type) {
        case 1:
          this.texts.converstionStart = text;
          break;
        case 2:
          break;
        case 3:
          this.texts.noPhone = text;
          break;
        case 4:
          this.texts.afterPhoneReceived = text;
          break;
        case 5:
          this.texts.requestPhone = text;
          break;
        case 6:
          this.texts.textForSharePhone = text;
          break;
        case 7:
          this.texts.textForEsputnikViber = text;
          break;
        case 8:
          this.texts.textForEsputnikViberImage = text;
          break;
        case 9:
          this.texts.textForEsputnikViberButton = text;
          break;
        case 10:
          this.texts.textForNewClients = text;
          break;
        default:
          break;
      }
    });
  }

  getEsputnikImageUploadParams = ({ meta }, ...rest) => {
    const jwtToken = localStorage.getItem('token');
    return {
      url: API_SETTINGS_UPLOAD_IMAGE,
      headers: { Authorization: `Bearer ${jwtToken}` },
    };
  };

  handleEsputnikImageUpload = (req, status, resp) => {
    if (status === 'done') {
      const response = JSON.parse(resp[0].xhr.response);
      if (response) {
        console.log('WREST', response);
        this.changeTextField('textForEsputnikViberImage', response.link);
        // if (!this.texts.textForEsputnikViberImage)
        // this.texts.textForEsputnikViberImage.content = response.link;
        // filename: "298851_main.jpeg"
        // link: "http://127.0.0.1:8000/uploads/2afaa98a-0807-450a-a7b3-cb9e001276b6.jpg"
        // type: "picture"
      }
    }
  }
}

const settingsStorage = new SettingsStorage();

export default settingsStorage;
